import { render, staticRenderFns } from "./v-announce-step.vue?vue&type=template&id=0d09e4d8&scoped=true&"
import script from "./v-announce-step.vue?vue&type=script&lang=js&"
export * from "./v-announce-step.vue?vue&type=script&lang=js&"
import style0 from "./v-announce-step.vue?vue&type=style&index=0&id=0d09e4d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d09e4d8",
  null
  
)

export default component.exports